import ErrorBoundary from 'sharedComponents/ErrorBoundary';
import { lazy, Suspense } from 'react';
import { Spinner } from '@7shifts/sous-chef';

const SchedulesPage = lazy(() => import('./pages/SchedulesPage'));

export const ROUTES = [
    {
        path: '/schedules',
        element: (
            <Suspense fallback={<Spinner block />}>
                <SchedulesPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    }
];
